import { render, staticRenderFns } from "./FruttoStatisticsTable.vue?vue&type=template&id=4d73fa3e&scoped=true&"
import script from "./FruttoStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./FruttoStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./FruttoStatisticsTable.vue?vue&type=style&index=0&id=4d73fa3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d73fa3e",
  null
  
)

export default component.exports